module.exports = __webpack_public_path__ + "img/cover2.55758bbb.png";